
import BaseList from '@/components/base/BaseList'
import UiIcon from '@/components/common/UiIcon.vue'
import {Component} from 'vue-property-decorator'

@Component({components: {UiIcon}})
export default class BaseListContainer extends BaseList {
  get sortableRows() {
    return (this.rows || []).filter((row: any) => row.orderable)
  }

  get rangeStart() {
    return this.total ? (this.page - 1) * this.limit + 1 : 0
  }

  get rangeEnd() {
    return Math.min(this.page * this.limit, this.total)
  }

  get paginationItems() {
    const pages: Array<number | string> = []
    for (let index = 1; index <= this.lastPage; index++) {
      if (index === 1 || index === this.lastPage || Math.abs(index - this.page) <= 1) pages.push(index)
      else if (pages[pages.length - 1] !== '…') pages.push('…')
    }
    return pages
  }

  onMobileSort(event: Event) {
    this.onSortHandler({sortBy: (event.target as HTMLSelectElement).value, orderBy: 'asc'})
  }
}
